
import { getAcceptabilityName, state } from "@/store";
import { defineComponent, PropType } from "vue";
export default defineComponent({
  props: {
    score: {
      type: null as unknown as PropType<number | null>,
      required: true,
    },
    title: {},
    alternative: {
      type: Number,
      required: true,
    },
    icon: {},
  },

  setup(props) {
    return {
      state,

      getColorName: (name: string) => {
        if (name === "pro") {
          return "green";
        } else if (name === "con") {
          return "red";
        } else if (name === "mix") {
          return "orange";
        } else {
          return "rgba(0,0,0,.2)";
        }
      },
      getAcceptabilityName,
    };
  },
});
